import type { SVGProps } from "react";

export function SupposeMark(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 42 32" fill="none" aria-hidden="true" {...props}>
      <path d="M5 27C12.8 27 14.5 15.7 22.2 15.7C27.1 15.7 29.1 8.1 36.8 5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" opacity=".48" />
      <circle cx="7" cy="26" r="3.6" fill="#f16f53" />
      <circle cx="22.3" cy="15.7" r="4.6" fill="#3f9fe0" />
      <circle cx="36" cy="5.8" r="5.6" fill="#7b6fd6" />
    </svg>
  );
}

export function SupposeLogo() {
  return (
    <span className="brand-lockup">
      <SupposeMark className="brand-mark" />
      <span className="brand-wordmark">Suppose</span>
    </span>
  );
}
